import type { ReactElement, FC } from 'react'
import React from 'react'

import Paragraph from '@vfuk/core-paragraph'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/CompanyInfo.style'

import type { CompanyInfoProps } from './CompanyInfo.types'

const CompanyInfo: FC<CompanyInfoProps> = ({
  companyInfo,
  additionalInfo,
  copyrightText,
  inverse,
  dataSelectorPrefix,
}: CompanyInfoProps): ReactElement => {
  return (
    <Styled.CompanyInfo data-selector={getDataSelector(dataSelectorPrefix)}>
      {companyInfo && (
        <Paragraph
          inverse={inverse}
          size={1}
          justify='center'
          dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'company-info-paragraph')}
        >
          {companyInfo}
        </Paragraph>
      )}
      {additionalInfo && (
        <Paragraph
          inverse={inverse}
          size={1}
          justify='center'
          dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'additional-info-paragraph')}
        >
          {additionalInfo}
        </Paragraph>
      )}
      <Paragraph
        inverse={inverse}
        size={1}
        justify='center'
        dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'copyright-paragraph')}
      >
        {copyrightText}
      </Paragraph>
    </Styled.CompanyInfo>
  )
}

export default CompanyInfo
